import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { QueryAdAccount, QueryAttribution, QueryDateRange, QueryWorkspace } from '../shared/query';
import { AttributionAttributed, AttributionCluster, AttributionTables } from './models';

type QueryArg = QueryDateRange & QueryAttribution;
interface ByResourceIds {
  resourceIds: number[];
}

const attribution = createApi({
  baseQuery: fetchBaseQuery({
    credentials: 'include',
    baseUrl: CROSS_API_URL + '/attribution',
  }),
  reducerPath: 'api.attribution',
  tagTypes: ['attribution'],
  endpoints: (builder) => ({
    attribution: builder.query<AttributionCluster, QueryArg & ByResourceIds & QueryAdAccount>({
      query: (args) => {
        let url = `/cluster?start_date=${args.start}&end_date=${args.end}`;
        url += ("&attribution_window=" + args.attributionWindow.join("&attribution_window="))
        url += ("&resource_ids=" + args.resourceIds.join("&resource_ids="))
        url += "&ad_account_id=" + args.adAccountId;
        return {
          url,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'max-age=0',
          },
        };
      }
    }),
    tables: builder.query<AttributionTables, QueryArg & ByResourceIds & QueryAdAccount>({
      query: (args) => {
        let url = `/tables?start_date=${args.start}&end_date=${args.end}`;
        url += ("&attribution_window=" + args.attributionWindow.join("&attribution_window="))
        url += ("&resource_ids=" + args.resourceIds.join("&resource_ids="))
        url += "&ad_account_id=" + args.adAccountId;
        return {
          url,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'max-age=0',
          },
        };
      }
    }),
    attributed: builder.query<AttributionAttributed, QueryArg & ByResourceIds & QueryAdAccount>({
      query: (args) => {
        let url = `/attributed?start_date=${args.start}&end_date=${args.end}`;
        url += ("&attribution_window=" + args.attributionWindow.join("&attribution_window="))
        url += ("&resource_ids=" + args.resourceIds.join("&resource_ids="))
        url += "&ad_account_id=" + args.adAccountId;
        return {
          url,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'max-age=0',
          },
        };
      }
    }),
  }),

});

export const { useAttributionQuery, useTablesQuery, useAttributedQuery } = attribution;
export default attribution;
